import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Row, Col, FormGroup, Label, Input, Button } from "reactstrap";
import { DatePicker } from "../../components/DatePicker";
import { connect } from "react-redux";
import ContentLayout from "../../components/ContentLayout";
import SummaryCard from "../../components/SummaryCard";
import { appHelpers } from "../../_helpers";
import { appConstants } from "../../_constants";
import { alertActions } from "../../_actions";
import TableFormat from "./WalletHistoryTable";
import NigerianFlag from "../../assets/scss/all/icons/flag-icon-css/flags/ng.svg";
import { walletServices } from "../../_services/wallet.service";
import EmptyRecordMessage from "../../components/EmptyRecordMessage/EmptyRecordMessage";
import moment from "moment";
import Select from "react-select";
import "./walletHistory.scss";

const WalletHistory = (props) => {
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [agencyId, setAgencyId] = useState(null); // State to store agency ID
  const [dateRange, setDateRange] = useState({
    startDate: moment().subtract(29, "days"),
    endDate: moment(),
  });
  const [transactionType, setTransactionType] = useState({
    value: null,
    label: "All",
  });
  const [transactionTypes, setTransactionTypes] = useState([
    { value: null, label: "All" },
  ]);

  const selectedAgency = JSON.parse(
    sessionStorage.getItem("selectedWalletData")
  );

  const navigateBack = () => {
    window.location.href = "/bulk-payment";
  };

  const getWalletHistory = (pageNumber = 1) => {
    const { dispatch } = props;

    let payload = {
      pageSize: pageSize,
      from: pageNumber,
      parameter: {
        startDate: moment(dateRange.startDate).format("YYYY-MM-DD") + "T00:00:00",
        endDate: moment(dateRange.endDate).format("YYYY-MM-DD") + "T23:59:59",
        ...(transactionType.value !== null && {
          transactionType: transactionType.value,
        }),
      },
      walletNumber: selectedAgency.walletNumber,
    };

    dispatch(alertActions.startRequest());

    walletServices.fetchWalletHistory(payload).then((res) => {
      dispatch(alertActions.stopRequest());
      let response = res.response;

      if (res.status === appConstants.SUCCESS_RESPONSE) {
        setTableData(response?.transactions || []);
        setTotalCount(response?.totalCount);
        setCurrentPage(pageNumber === 0 ? 1 : pageNumber);
        setAgencyId(response?.agencyId || null); // Set agency ID
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
      }
    });
  };

  const getTransactionTypes = () => {
    const { dispatch } = props;
    dispatch(alertActions.startRequest());
    walletServices.getWalletTransactionTypes().then((res) => {
      dispatch(alertActions.stopRequest());
      let response = res.response;
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        const transformedData =
          response?.data?.map(({ id, name }) => ({
            value: id,
            label: name,
          })) || [];
        setTransactionTypes([
          {
            value: null,
            label: "All",
          },
          ...(transformedData || []),
        ]);
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
      }
    });
  };

  const downloadTransactions = (docType) => {
    const { dispatch } = props;
    dispatch(alertActions.startRequest());
    let payload = {
      pageSize: pageSize,
      from: currentPage,
      parameter: {
        startDate: moment(dateRange.startDate).format("YYYY-MM-DD") + "T00:00:00",
        endDate: moment(dateRange.endDate).format("YYYY-MM-DD") + "T23:59:59",
        ...(transactionType.value !== null && {
          transactionType: transactionType.value,
        }),
        downloadFormat: docType || "PDF",
      },
      walletNumber: selectedAgency.walletNumber,
    };
    walletServices.downloadWalletTransaction(payload).then((res) => {
      dispatch(alertActions.stopRequest());
      let response = res.response;
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        appHelpers.downloadFile(response?.responseType.downloadUrl, "Wallet Transactions");
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
      }
    });
  };

  const handleCreateInvoiceClick = () => {
    props.history.push("/create-invoice", {
      selectedAgency,
      isFundingWallet: false,
      organizationDetails: {
        id: agencyId,
      },
    });
  };

  const handleFundWallet = () => {
    props.history.push("/create-invoice", {
      from: "/wallet-history",
      isFundingWallet: true,
      selectedAgency,
      organizationDetails: {
        id: agencyId,
      },
    });
  };

  // Fetch data on component mount
  useEffect(() => {
    getTransactionTypes();
    getWalletHistory();
  }, []);

  const downloadDoc = (docType) => {
    downloadTransactions(docType);
  };

  const changeDatePicker = (date, type) => {
    if (type === "startDate") {
      setDateRange({ ...dateRange, startDate: date });
    } else if (type === "endDate") {
      setDateRange({ ...dateRange, endDate: date });
    }
  };

  const handleSelectChange = (selectedTransactionType) => {
    setTransactionType(selectedTransactionType);
  };

  const clearFilter = () => {
    setTransactionType({ value: null, label: "All" });
    setDateRange({
      startDate: moment().subtract(1, "month"),
      endDate: moment(new Date(), "YYYY-MM-DD"),
    });
    getWalletHistory(1);
  };

  return (
    <ContentLayout
      requesting={props.requesting}
      pageTitle={
        <span onClick={navigateBack} className="wallet-page-title">
          <FaArrowLeft className="icon-margin" /> {selectedAgency.customerName}
        </span>
      }
      actions={<></>}
    >
      <div className="wallet-history-page">
        <div className="wallet-card">
          <p className="title">Wallet Balance</p>
          <SummaryCard
            className
            cardTitle={
              <span className="currency-title">
                <img src={NigerianFlag} className="nigerian-icon" /> Nigerian
                Naira
              </span>
            }
            bgColor={"#E3F8EF"}
            topValue={
              <span className="currency-subtitle">AVAILABLE BALANCE</span>
            }
            bottomValue={
              <span className="amount">
                ₦{appHelpers.numbersWithCommas(selectedAgency?.balance || 0)}
              </span>
            }
          />
        </div>
        <div className="buttons-container">
          <Button
            outline
            color="info"
            className="big-action-btn btn-rounded mr-2"
            onClick={handleFundWallet}
          >
            Fund wallet
            <FaArrowRight className="icon-margin icon-one" />
          </Button>
          <Button
            outline
            color="info"
            className="big-action-btn btn-rounded mr-2"
            onClick={handleCreateInvoiceClick}
          >
            Create invoice
            <FaArrowRight className="icon-margin icon-two" />
          </Button>
        </div>
        <div>
          <Row>
            <Col md={"4"}>
              <FormGroup>
                <Label for="date">Start Date</Label>
                <DatePicker
                  classNamePrefix="date-picker"
                  date={dateRange.startDate}
                  onChange={(date) => changeDatePicker(date, "startDate")}
                />
              </FormGroup>
            </Col>
            <Col md={"4"}>
              <FormGroup>
                <Label for="date">End Date</Label>
                <DatePicker
                  className="date-picker"
                  date={dateRange.endDate}
                  onChange={(date) => changeDatePicker(date, "endDate")}
                />
              </FormGroup>
            </Col>
            <Col md={"4"}>
              <FormGroup>
                <Label>Transaction Type</Label>
                <Select
                  className={"select-list"}
                  classNamePrefix={"react-select"}
                  value={transactionType}
                  onChange={handleSelectChange}
                  options={transactionTypes}
                  placeholder={"Select Audit Type..."}
                  defaultValue={transactionType}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row className="mt-6">
            <Col className="d-flex justify-content-end gap-2 mb-6">
              <Button
                className="btn-rounded px-4 custom-ash"
                onClick={() => clearFilter()}
              >
                Clear
              </Button>
              <Button
                color="success"
                className="btn-rounded px-4 text-white ml-3"
                onClick={() => getWalletHistory(1)}
              >
                Search
              </Button>
            </Col>
          </Row>
        </div>
        <div>
          {tableData.length === 0 && (
            <EmptyRecordMessage message={"No transactions record"} />
          )}
          {tableData.length > 0 && (
            <div>
              <div>
                <p className="title mb-0">Transaction history</p>
              </div>
              <Row>
                <Col md={"12"}>
                  <TableFormat
                    currentPage={currentPage}
                    fetchMore={getWalletHistory}
                    pageSize={pageSize}
                    totalCount={totalCount}
                    apiData={tableData}
                    downloadDoc={downloadDoc}
                  />
                </Col>
              </Row>
            </div>
          )}
        </div>
      </div>
    </ContentLayout>
  );
};

function mapStateToProps(state) {
  const {
    alert,
    user,
    requesting,
    userData,
    displayGeneralAlert,
    branding,
    agencyId,
  } = state;
  return {
    alert,
    user,
    requesting,
    userData,
    displayGeneralAlert,
    branding,
    agencyId: state.agency ? state.agency.agencyId : null,
  };
}

export default connect(mapStateToProps)(WalletHistory);
